module.exports = __webpack_public_path__ + "img/send.37194782.svg";